import { render } from "./PicnicIcon.vue?vue&type=template&id=7d5890d1"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__